const fbInit = () => {
  const appId = process.env.FACEBOOK_KEY;
  window.fbAsyncInit = () => {
    window.FB.init({
      appId,
      cookie: true,
      xfbml: true,
      version: "v3.2"
    });
    window.FB.AppEvents.logPageView();
  };
  (function(d, s, id) {
    var js,
      fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement(s);
    js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs && fjs.parentNode.insertBefore(js, fjs);
  })(document, "script", "facebook-jssdk");
};

const facebookLogin = facebookLoginHandler => {
  if (!window.FB) return;

  window.FB.getLoginStatus(response => {
    if (response.status === "connected") {
      facebookLoginHandler(response);
    } else {
      window.FB.login(facebookLoginHandler, { scope: "public_profile,email" });
    }
  });
};

export { facebookLogin, fbInit };
